import { traceContextManager } from './TraceContextManager';

export { TraceProvider, useTrace } from './TraceContext';
export { traceContextManager } from './TraceContextManager';
export { getTracer } from './otelProvider';
export { formatTraceparent } from './traceUtils';

export const withTrace =
  traceContextManager.withTrace.bind(traceContextManager);
